// extracted by mini-css-extract-plugin
export default {"container":"zegoLoading_container__O9jLf","content":"zegoLoading_content__qRk8n","loadSvg":"zegoLoading_loadSvg__p54HA","text":"zegoLoading_text__-c+Bk"};